import React from 'react';
import { useTheme } from '../../app/providers/ThemeProvider';

/**
 * Light/dark switch.
 *
 * The light theme and its token set already existed and were fully specified in
 * tokens.css, but nothing in the UI ever called toggleTheme() — so the whole
 * theme was unreachable. This is the control that reaches it.
 *
 * Inline SVG rather than an icon font: the header renders before webfonts
 * settle, and a missing glyph here would leave a blank button.
 */
const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme !== 'light';
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <button
      type="button"
      className="a-theme-toggle"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      // Announces the state, not just the action, to assistive tech.
      aria-pressed={!isDark}
    >
      {isDark ? (
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
          <path
            fill="currentColor"
            d="M12 3a9 9 0 1 0 9 9 7 7 0 0 1-9-9Z"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="4.2" fill="currentColor" />
          <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
            <path d="M12 2.6v2.2M12 19.2v2.2M2.6 12h2.2M19.2 12h2.2" />
            <path d="M5.4 5.4l1.6 1.6M17 17l1.6 1.6M18.6 5.4L17 7M7 17l-1.6 1.6" />
          </g>
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;
